// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-select-card[data-v-1b818ca0]{background-color:var(--border-color);padding:1rem}.product-select-card--countdown-wrapper[data-v-1b818ca0]{background-color:var(--product-select-header-bg);color:var(--white);padding:2rem;text-align:center}.product-select-card__row[data-v-1b818ca0]{row-gap:10px}.product-select-card__title[data-v-1b818ca0]{font-size:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
